import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { FEES_HELP_LINKS } from '@sorare/core/src/components/fiatWallet/CreateFiatWallet/externalLinks';
import { useSportContext } from '@sorare/core/src/contexts/sport';

export const useFeesDetailsLink = () => {
  const { sport } = useSportContext() || {};
  return FEES_HELP_LINKS[sport || Sport.FOOTBALL];
};
